export const Color = {
  PuertoRico: '#51c3a0',
  EbonyClay: '#292d3e',
  HeavyMetal: '#272822',
  AthensGray: '#EBEDF0',
  CaribbeanGreen: '#01C49C',
  NeonCarrot: '#FF993C',
  SunsetOrange: '#F94848',
  CloudBurst: '#1b2653',
  Primary: '#38c2a0',
  BaliHai: '#8B9AB6',
}
